import { CompanyInfoViewModel } from './../models/account-ledger.model';
import { QantasRewardsService } from './../services/qantas-rewards.service';
import { Observable } from 'rxjs';
import { MyAccountService } from './../services/myAccount.service';
import { Subject } from 'rxjs';
import { CommonService } from './../services/common.service';
import { FormControl, FormGroup, Validators, FormBuilder } from '@angular/forms';
import { Component, OnInit, OnDestroy } from '@angular/core';
import { AccountManagerDetails, Mobile, QantasRewardsModel, QBRMemberJoinModel, Source } from '../models/QantasRewardsModel';
import { Router } from '@angular/router';
import { takeUntil } from 'rxjs/operators';

@Component({
  selector: 'app-rewards',
  templateUrl: './rewards.component.html',
  styleUrls: ['./rewards.component.css']
})
export class RewardsComponent implements OnInit, OnDestroy {

  isLoading = false;
  isRegistered = false;
  isValidABN = false;
  showRegisterForm = false;
  showSuccess = false;
  showError = false;
  qantasError = '';
  countryCode = '+61';
  abnNumber = '';
  emailAddress = '';
  promoCode = 'PJDICKERDATA';
  sourceId = '';
  titleList = ['Mr', 'Mrs', 'Miss', 'Ms', 'Dr', 'Unknown'];
  registerGroup = null;

  accessToken = '';
  model: QantasRewardsModel;

  validations = [
    { path: 'title', class: 'titleValidate', message: 'Please select title' },
    { path: 'firstName', class: 'firstNameValidate', message: 'Please enter first name' },
    { path: 'lastName', class: 'lastNameValidate', message: 'Please enter last name' },
    { path: 'mobileNumber', class: 'mobileNumberValidate', message: 'Please enter mobile number' }
  ];


  ngUnsubscirbe: Subject<void> = new Subject<void>();

  constructor(
    private commonService: CommonService,
    private myAccountService: MyAccountService,
    private qantasRewardsService: QantasRewardsService,
    private fb: FormBuilder,
    private router: Router
  ) {
    commonService.emitUpdateSideBarActiveItem('qantas-rewards');
    this.registerGroup = this.fb.group({
      abnNumber: [{value: '', disabled: true}],
      title: ['', Validators.required],
      firstName: ['', Validators.required],
      lastName: ['', Validators.required],
      emailAddress: ['', Validators.email],
      mobileNumber: ['', Validators.required],
      promoCode: [''],
    });
  }

  navigateTo(url: string) {
    this.router.navigate([url]);
  }

  ngOnInit() {
    this.showRegisterForm = false;
    this.showSuccess = false;
    this.showError = false;
    this.isLoading = true;

    this.myAccountService.getCompanyProfile()
        .pipe(takeUntil(this.ngUnsubscirbe))
        .subscribe((value: CompanyInfoViewModel) => {
          if (value) {
            this.abnNumber = value.abn;
            this.emailAddress = value.emailAddress;
            this.checkQBRStatus();
          }
          this.patchFormValues();
          this.isLoading = false;
        });

  }

  checkQBRStatus() {
    this.qantasRewardsService.QBRAccountStatus(this.abnNumber)
      .pipe(takeUntil(this.ngUnsubscirbe))
      .subscribe(res => {
        var value = JSON.parse(res);
           if (value.memberStatus?.length) 
            this.isRegistered = value.memberStatus.toUpperCase() === 'ACTIVE' ? true : false;
      });
  }

  patchFormValues() {
    this.registerGroup.patchValue({
      abnNumber: this.abnNumber,
      emailAddress: this.emailAddress,
      promoCode: this.promoCode
    });
  }

  checkValidABN() {
    this.qantasRewardsService.ABRLookup(this.abnNumber)
    .pipe(takeUntil(this.ngUnsubscirbe))
    .subscribe(res => {
      var value = JSON.parse(res);

         this.isValidABN = value.abnStatus.toUpperCase() === 'ACTIVE' ? true : false;
    });
  }

  submitRegisterForm() {
    if (this.registerGroup.valid) {

      // get access token before submit
      if (!this.accessToken) {
        this.getAccessToken();
        return;
      }
      this.isLoading = true;

      const mobile = {} as Mobile;
      mobile.countryCode = this.countryCode.replace('+', '');
      mobile.number = this.registerGroup.get('mobileNumber').value.toString();

      const accountManagerDetails = {} as AccountManagerDetails;
      accountManagerDetails.title = this.registerGroup.get('title').value;
      accountManagerDetails.firstName = this.registerGroup.get('firstName').value;
      accountManagerDetails.lastName = this.registerGroup.get('lastName').value;
      accountManagerDetails.emailAddress = this.registerGroup.get('emailAddress').value;
      accountManagerDetails.mobile = mobile;

      const source = {} as Source;
      source.sourceId = 'PARTNER';

      const model = {} as QantasRewardsModel;
      model.abn = this.abnNumber;
      model.accountManagerDetails = accountManagerDetails;
      // model.promoCode = this.promoCode;
      model.source = source;
      
      const memberJoinModel = {} as QBRMemberJoinModel;
      memberJoinModel.accessToken = this.accessToken;
      memberJoinModel.qantasRewardsModel = model;

      this.qantasRewardsService.QBRMemberJoin(memberJoinModel)
          .pipe(takeUntil(this.ngUnsubscirbe))
          .subscribe(res => {
            if (res.status){
              this.showRegisterForm = false;
              this.showSuccess = true;
              this.showError = false;
              this.isRegistered = true;
              this.isLoading = false;
            }
            else{
              this.qantasError = res.responseMessage;
              this.showRegisterForm = false;
              this.showSuccess = false;
              this.showError = true;
              this.isRegistered = false;
              this.isLoading = false;
            }
            
          },
          error => {
            
            this.qantasError = error.responseMessage;
            this.showRegisterForm = false;
            this.showSuccess = false;
            this.showError = true;
            this.isRegistered = false;
            this.isLoading = false;
          });


    } else {
      this.validations.forEach(item => {
        this.validateField(item);
      })
    }
  }

  getAccessToken() {
    this.qantasRewardsService.GetIdentityToken()
    .pipe(takeUntil(this.ngUnsubscirbe))
    .subscribe(response => {
      const res = JSON.parse(response);
      this.accessToken = res.access_token;
      this.submitRegisterForm();
    },
    (error: any) => {
      this.commonService.implementToast('Cannot get access token from Qantas Business Rewards', 'Error');
    });
  }

  returnToForm() {
    this.showError = false; 
    this.showRegisterForm = true;
  }

  validateField(validation: any): void {
    if (this.registerGroup.get(validation.path).hasError('required')) {
      this.commonService.showValidator('.' + validation.class, validation.message, 'right', 'error');
    }
  }


  ngOnDestroy() {
    this.commonService.emitUpdateSideBarActiveItem('');
    this.ngUnsubscirbe.next();
    this.ngUnsubscirbe.complete();
  }


}
